import { useState } from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import { useObjectCard } from '../context/ObjectCardProvider';
import OffOperationInfo from '../OffOperationInfo';
import ProposalShortageBlock from '../ProposalShortage';
import ProductsTableBody from './ProductsTableBody/ProductsTableBody';
import AddProductsDropdown from './ProductsTableBody/AddProductsDropdown';
import CheckedRowsMenu from './shared/CheckedRowsMenu';

const ObjectTabProducts = () => {
    const { t } = useTranslation(['Objects']);
    const { vObject } = useObjectCard();
    const [showSpinnerProducts, setShowSpinnerProducts] = useState(false);
    const [showOperationInfo, setShowOperationInfo] = useState(false);
    const [checkedIds, setCheckedIds] = useState<number[]>([]);
    const rowIds = (vObject?.operations || []).map((operation) => operation.ID);
    const allChecked = rowIds.length > 0 && rowIds.every((id) => checkedIds.includes(id));

    return (
        <>
            <OffOperationInfo
                show={showOperationInfo}
                setShow={setShowOperationInfo}
            />

            <div>
                <ProposalShortageBlock kind="products" />

                <div className="d-flex justify-content-end align-items-center gap-2">
                    <CheckedRowsMenu
                        kind="products"
                        checkedIds={checkedIds}
                        setCheckedIds={setCheckedIds}
                        setBusy={setShowSpinnerProducts}
                    />
                    <AddProductsDropdown />
                </div>

                {showSpinnerProducts && <SpinnerBlock onlyBlur={true} show={true} />}
                <div className="crm-table-wrap">
                    <Table className="ProductObjectTable table-hover table">
                        <thead>
                            <tr className="bg-light">
                                <td className="head-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        disabled={rowIds.length === 0}
                                        checked={allChecked}
                                        onChange={(e) => {
                                            setCheckedIds((prev) => {
                                                if (e.target.checked) {
                                                    return Array.from(new Set([...prev, ...rowIds]));
                                                }
                                                return prev.filter((id) => !rowIds.includes(id));
                                            });
                                        }}
                                    />
                                </td>
                                <td className="head-prodname">{t('productFields.name')}</td>
                                <td className="head-price">{t('productFields.price')}</td>
                                <td className="head-count">{t('productFields.count')}</td>
                                <td className="head-amount">{t('productFields.amount')}</td>
                                <td className="head-warehouse">{t('productFields.warehouse')}</td>
                                <td className="head-actions">{t('productFields.actions')}</td>
                            </tr>
                        </thead>
                        <ProductsTableBody
                            checkedIds={checkedIds}
                            setCheckedIds={setCheckedIds}
                            showOperationInfo={showOperationInfo}
                            setShowOperationInfo={setShowOperationInfo}
                            setShowSpinnerProducts={setShowSpinnerProducts}
                        />
                    </Table>
                </div>
            </div>
        </>
    );
};

export default ObjectTabProducts;
